import { exibirErros } from "componentes/mensagem/actions";
export const ATUALIZAR_USUARIO = "usuario/ATUALIZAR_USUARIO";
export const LIMPAR_USUARIO = "usuario/LIMPAR_USUARIO";

export const buscarUsuarioLogado = () => dispatch => {

  dispatch({ type: LIMPAR_USUARIO });
  const usuarioLogadoUrl = "/services/api/usuarios/usuario-logado";

  fetch(usuarioLogadoUrl)
    .then(ru => ru.ok ? ru.json() : Promise.reject(ru))
    .then(usuarioLogado => {
      dispatch({ type: ATUALIZAR_USUARIO, usuarioLogado });
    })
    .catch(erros => dispatch(exibirErros(erros)));
}


// WEBPACK FOOTER //
// ./src/componentes/usuario/actions.js